const LoyaltyMegaWalletModule = () => import('./LoyaltyMegaWalletModule.vue')
const LoyaltyMegaWallet = () => import('./views/LoyaltyMegaWallet.vue')
const LoyaltyMegaWalletTransactionIndex = () =>
  import('./views/LoyaltyMegaWalletTransactionIndex.vue')

export const loyaltyMegaWalletRoute = {
  path: '/loyalty',
  component: LoyaltyMegaWalletModule,
  meta: {
    title: 'LoyaltyMegaWallet',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: 'mega-wallet',
      name: 'loyaltyMegaWallet',
      meta: {
        permission: 'loyalty.view',
      },
      component: LoyaltyMegaWallet,
    },
    {
      path: 'mega-wallet-transactions',
      name: 'loyaltyMegaWalletTransaction',
      meta: {
        permission: 'loyalty.view',
      },
      component: LoyaltyMegaWalletTransactionIndex,
    },
  ],
}
